export default {
  data() {
    return {
      productList: [
        {
          id: '1',
          title: 'Встречи',
          description: 'Сервис для\u00A0онлайн-встреч и\u00A0совещаний',
          description_mobile: 'Сервис для\u00A0онлайн-встреч<br/>и\u00A0совещаний',
          icon: 'icon-meetings',
          image: 'meetings-coin',
          link: '/products/meetings/',
        },
        {
          id: '2',
          title: 'Чаты',
          description: 'Корпоративный мессенджер для\u00A0всей компании',
          description_mobile: 'Корпоративный мессенджер<br/>для\u00A0всей компании',
          icon: 'icon-messengers',
          image: 'messengers-coin',
          link: '/products/messenger/',
        },
        {
          id: '3',
          title: 'Задачи',
          description: 'Сервис для управления рабочими задачами',
          description_mobile: 'Сервис для управления<br/>рабочими задачами',
          icon: 'icon-task-management',
          image: 'task-management-coin',
          link: '/products/task-management/',
        },
        {
          id: '4',
          title: 'Доски',
          description: 'Онлайн-доска для\u00A0совместной работы',
          description_mobile: 'Онлайн-доска<br/>для\u00A0совместной работы',
          icon: 'icon-boards',
          image: 'boards-coin',
          link: '/products/boards/',
        },
        {
          id: '5',
          title: 'Вебинары',
          description: 'Сервис для\u00A0вебинаров и\u00A0онлайн-обучения',
          description_mobile: 'Сервис для\u00A0вебинаров<br/>и\u00A0онлайн-обучения',
          icon: 'icon-webinars',
          image: 'webinars-coin',
          link: '/products/webinar/',
        },
        {
          id: '6',
          title: 'Курсы',
          description:
            'Сервис для\u00A0создания онлайн-курсов и\u00A0организации обучения',
          description_mobile: 'Сервис для\u00A0создания онлайн-курсов<br/>и\u00A0организации обучения',
          icon: 'icon-westudy',
          image: 'westudy-coin',
          link: '/products/westudy/',
        },
        {
          id: '7',
          title: 'Формы',
          description:
            'Конструктор тестов и\u00A0опросов с\u00A0автопроверкой ответов',
          description_mobile: 'Сервис для\u00A0проведения тестов,<br/>опросов и\u00A0исследований',
          icon: 'icon-forms',
          image: 'forms-coin',
          link: '/products/forms/',
        },
        {
          id: '8',
          title: 'Оборудование',
          description: 'Оборудование и\u00A0ПО для\u00A0переговорных комнат',
          description_mobile: 'Оборудование и\u00A0ПО для\u00A0оснащения<br/>переговорных комнат',
          icon: 'icon-equipment',
          image: 'equipment-coin',
          link: '/products/software-and-equipment/',
        },
        {
          id: '9',
          title: 'Comdi',
          description:
            'Сервисы для\u00A0гибридных и\u00A0онлайн-мероприятий с\u00A0видеосъемкой и\u00A0цифровой платформой',
          description_mobile: 'Сервисы для\u00A0гибридных<br/>и\u00A0онлайн-мероприятий',
          icon: 'icon-comdi',
          image: 'comdi-coin',
          link: '/products/comdi/',
        },
      ],
    }
  }
}
